import { Box, Button, TextField, Typography } from '@mui/material';
import { FC, useEffect } from 'react';

export type TTypeField = 'text' | 'phone' | 'email' | 'number';

export type IEditableFieldProps = {
	firstValue: string;
	// onChange: (value: string) => void;
	label: string;
	error: string;
	setError: (error: string) => void;
	value: string;
	setValue: (value: string) => void;
	isRequired?: boolean;
	type?: TTypeField;
	validationPattern?: RegExp | null;
	errorComment?: string;
};

export const EditableField: FC<IEditableFieldProps> = ({
	firstValue,
	label,
	// onChange,
	error,
	setError,
	value,
	setValue,
	isRequired = true,
	type = 'text',
	validationPattern = null,
	errorComment = '',
}) => {
	// const [value, setValue] = useState(firstValue);
	// const [error, setError] = useState('');
	const validateEmail = (email: string): boolean => {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return emailRegex.test(email);
	};

	const validate = (val: string): boolean => {
		if (!validationPattern) return true;
		return validationPattern.test(val);
	};

	const handleValidate = (val: string) => {
		if (!val && isRequired) {
			setError(`${label} is required`);
		} else if (errorComment && !validate(val)) {
			setError(errorComment);
		} else {
			setError('');
		}
		setValue(val);
	};

	useEffect(() => {
		handleValidate(firstValue);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [firstValue]);

	return (
		<Box
			sx={{
				width: '100%',
				display: 'flex',
				flexDirection: 'column',
				// alignItems: 'center',
				// justifyContent: 'center',
				gap: '5px',
				mt: '10px',
				mb: '10px',
			}}
		>
			<>
				<TextField
					size="small"
					value={value}
					InputLabelProps={{
						style: {
							fontSize: '.8rem',
							marginTop: '1px',
						},
					}}
					sx={{
						'& .MuiInputBase-root': {
							minWidth: '100%',
							maxHeight: '30px',
						},
						'& .MuiFormHelperText-root': {
							fontSize: '.6rem',
							lineHeight: '.6rem!important',
						},
						'& .MuiFormLabel-root': {
							lineHeight: '.8rem!important',
						},
						'& legend': {
							fontSize: '.6rem',
						},
					}}
					label={label}
					onChange={(e) => handleValidate(e.target.value)}
					error={!!error}
					// placeholder={label}
					type={type}
					helperText={error}
				/>
				{/* {error && (
					<Typography
						// variant="caption"
						color="error"
						sx={{
							fontSize: '.6rem',
							lineHeight: '.6rem!important',
							// mt: '.2rem',
							ml: '.5rem',
						}}
					>
						{error}
					</Typography>
				)} */}
			</>

			{/* <Button
				variant="contained"
				color="primary"
				size="small"
				sx={{
					borderRadius: '12px!important',
					textTransform: 'none',
					maxHeight: '24px',
					width: '100%',
				}}
				disabled={!!error}
			>
				{!firstValue ? `Add ${label}` : `Update ${label}`}
			</Button> */}
		</Box>
	);
};
